import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  setItem<T>(key: string, value: T): void {
    try {
      if (typeof value === 'string') {
        localStorage.setItem(key, value);
      } else {
        localStorage.setItem(key, JSON.stringify(value));
      }
    } catch (error) {
      console.error(`Error storing item ${key}:`, error);
    }
  }

  getItem<T>(key: string, defaultValue: T = null as unknown as T): T {
    try {
      const value = localStorage.getItem(key);
      if (!value) {
        return defaultValue;
      }
      
      try {
        return JSON.parse(value);
      } catch {
        return value as unknown as T;
      }
    } catch (error) {
      console.error(`Error retrieving item ${key}:`, error);
      return defaultValue;
    }
  }

  setString(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      console.error(`Error storing string ${key}:`, error);
    }
  }

  getString(key: string, defaultValue = ''): string {
    try {
      return localStorage.getItem(key) || defaultValue;
    } catch (error) {
      console.error(`Error retrieving string ${key}:`, error);
      return defaultValue;
    }
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }

  hasItem(key: string): boolean {
    return localStorage.getItem(key) !== null;
  }
}